import { useContext } from 'react';
import { createContext } from 'react';

import { ProductHighlightWrapperProps } from '../@types/ProductHighlightWrapperProps';

export const ProductHighlightWrapperContext = createContext<ProductHighlightWrapperProps>(
	{} as ProductHighlightWrapperProps,
);

ProductHighlightWrapperContext.displayName = 'ProductHighlightWrapper';

const ProductHighlightWrapperProvider = (props: ProductHighlightWrapperProps) => (
	<ProductHighlightWrapperContext.Provider value={props}>{props.children}</ProductHighlightWrapperContext.Provider>
);

export const useProductHighlightWrapper = () => {
	const context = useContext(ProductHighlightWrapperContext);

	return context;
};

export default ProductHighlightWrapperProvider;
